export { default as CookiebotTrigger } from './cookiebot-trigger'
